import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed z-40 h-full w-full top-0 left-0" }
const _hoisted_2 = { class: "max-w-480px w-full" }
const _hoisted_3 = { class: "py-6 bg-permaBlack5 rounded-3xl" }
const _hoisted_4 = { class: "text-xl" }

import { withDefaults } from 'vue'
import ModalMask from './ModalMask.vue'
import TitleArea from './TitleArea.vue'

interface Props {
  visible: boolean
  title: string
  showIcon?:boolean
}
interface Emits {
  (e: 'close'): void
  (e: 'confirm'):void

}

export default /*#__PURE__*/_defineComponent({
  props: {
    visible: { default: true },
    title: { default: '' },
    showIcon: { default: true }
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'close'): void
  (e: 'confirm'):void

}), expose: any, slots: any, attrs: any }) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createVNode(ModalMask, {
          visible: __props.visible,
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emits('close')), ["self"]))
        }, null, 8, ["visible"]),
        _createElementVNode("div", {
          class: "px-8 mb:px-0 overflow-y-auto scroll-area h-full pb-28 pt-10 flex items-center flex-col w-full fixed z-30 top-20 transform",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (emits('close')), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(TitleArea, {
                class: "mx-6 border-white border-b border-opacity-10",
                "show-icon": __props.showIcon,
                onClose: _cache[1] || (_cache[1] = ($event: any) => (emits('close')))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(__props.title), 1)
                ]),
                _: 1
              }, 8, ["show-icon"]),
              _createElementVNode("div", null, [
                _renderSlot(_ctx.$slots, "default")
              ])
            ])
          ])
        ])
      ], 512), [
        [_vShow, __props.visible]
      ])
    ]),
    _: 3
  }))
}
}

})